<template>
  <div class="mix-popup content_w_710" :id="content.key">
    <div
      class="mix-popup-item"
      :class="content.templateType == 2 ? 'mix-popup-item-half' : ''"
      v-for="item in content.content"
      :key="item.key"
    >
      <tempIndex :content="item" :size="content.templateType == 2 ? 'small' : 'normal'"></tempIndex>
    </div>
  </div>
</template>
<script>
/*
媒体组件
*/
import tempIndex from "./template/index.vue";

export default {
  name: "mixPopupIndex",
  components: {
    tempIndex,
  },
  props: {
    content: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.content_w_710 {
  width: calc(100% - 48rem);
  margin: 50rem auto;
}
.mix-popup{
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: center;
  
  .mix-popup-item{
    margin-bottom: 20rem;
  }

  .mix-popup-item-half{
    width: 340rem;
  }
}
</style>